import React from 'react'; 
import { withStyles, Grid, Typography, ButtonBase, withRouter } from '../../../material-ui';

class MatchLeagueItemArea extends React.Component {

    _onClick = () => {
        let data = Object.assign({ typeId: this.props.typeId }, this.props.data);
        this.props.history.push({ pathname: '/matcharea/' + this.props.typeId, data: data });
    }

    render() {
        const { classes, data } = this.props;
        return (
            <ButtonBase className={classes.buttonBase} onClick={() => this._onClick()}>
                <Grid container direction='column' alignItems='center' justifyContent='center' className={classes.root}>
                    <Typography className={classes.contentText}>{data.name_zh}</Typography>
                    <Typography className={classes.subTitle}>{data.name_en}</Typography>
                </Grid>
            </ButtonBase>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        maxWidth: 110,
        maxHeight: 60,
        borderRadius: 10,
        backgroundColor: '#F5F5F5'
    },
    contentText: {
        color: '#0D0D0D',
        fontSize: 12,
        marginTop: 4,
    },
    subTitle: {
        color: '#878787',
        fontSize: 10,
        marginTop: 4,
        marginBottom: 4,
    },
    buttonBase: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
        width: '100%',
        height: '100%',
        maxWidth: 110,
        maxHeight: 60,
    }
}))(MatchLeagueItemArea));